import * as Products from '../services/Products'

export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS'
export const RECEIVE_PRODUCT = 'RECEIVE_PRODUCT'
export const RECEIVE_PRODUCT2 = 'RECEIVE_PRODUCT2'

function receiveProducts(state, query, products) {
  return {
    type: RECEIVE_PRODUCTS,
    query,
    products
  }
}

export const fetchProducts = (query) => (dispatch, getState) => {
  const state = getState()
  let subsidiaryId = state.currentUser.subsidiary
  Products.searchProducts(query, subsidiaryId).then((data) => dispatch(receiveProducts(state, query, data)))
}

export const fetchProductsDashboard = (query) => (dispatch, getState) => {
  const state = getState()
  let subsidiaryId = state.currentUser.subsidiary
  return Products.searchProductsDashboard(query, subsidiaryId).then((data) => dispatch(receiveProducts(state, query, data)))
}

export const fetchActiveLicensesPercentageByProductEan = (query) => (dispatch, getState) => {
  const state = getState()
  return Products.searchLicenseActivePercentageByProductEan(query).then((data) => dispatch(receiveProductActivePercentage(state, query, data)))
}

function receiveProductActivePercentage(state, product, data) {
  return {
    type: RECEIVE_PRODUCT2,
    data: data ? data : data
  }
}

function receiveProduct(state, product) {
  return {
    type: RECEIVE_PRODUCT,
    product: product ? product : {id: -1}
  }
}

export const fetchProduct = (id) => (dispatch, getState) => {
  const state = getState()
  const subsidiaryId = state.currentUser.subsidiary
  Products.getProduct(id, subsidiaryId).then((data) => dispatch(receiveProduct(state, data)))
}

export const updateProduct = (product) => (dispatch, getState) => {
  const state = getState()
  const subsidiaryId = state.currentUser.subsidiary
  return Products.updateProduct(product, subsidiaryId)
}
